(() => {



  const root = window.Shopify?.routes?.root || '/';



  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: window.Shopify?.currency?.active || 'GBP' }).format(cents / 100);



  const select = (q, within = document) => within.querySelector(q);



  const selectAll = (q, within = document) => [...within.querySelectorAll(q)];



  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);



  const header = select('[data-header]');



  const welcome = select('[data-welcome-offer]');



  const welcomeOpen = select('[data-welcome-open]');



  const welcomeKey = 'anivault-welcome10-seen-v1';



  let welcomeTimer;



  function rememberWelcome() { try { localStorage.setItem(welcomeKey, '1'); } catch { /* Browsing with storage disabled remains supported. */ } }



  function closeWelcome() {



    if (!welcome) return;



    clearTimeout(welcomeTimer);



    const hadFocus = welcome.contains(document.activeElement);



    welcome.hidden = true;



    welcomeOpen?.setAttribute('aria-expanded', 'false');



    rememberWelcome();



    if (hadFocus) welcomeOpen?.focus();



  }



  function openWelcome(manual = false) {



    if (!welcome) return;



    clearTimeout(welcomeTimer);



    welcome.hidden = false;



    welcomeOpen?.setAttribute('aria-expanded', 'true');



    rememberWelcome();



    if (manual) select('[data-welcome-close]', welcome)?.focus();



  }



  welcomeOpen?.addEventListener('click', () => welcome.hidden ? openWelcome(true) : closeWelcome());



  select('[data-welcome-close]')?.addEventListener('click', closeWelcome);



  welcome?.querySelector('a')?.addEventListener('click', rememberWelcome);



  if (welcome?.querySelector('[data-welcome-signup-result]')) openWelcome();



  if (welcome?.hasAttribute('data-welcome-auto')) {



    let seen = false;



    try { seen = localStorage.getItem(welcomeKey) === '1'; } catch { seen = true; }



    if (!seen) welcomeTimer = setTimeout(() => {



      if (!document.body.classList.contains('drawer-open') && !document.querySelector('[data-menu-toggle][aria-expanded="true"], [data-search-toggle][aria-expanded="true"]')) openWelcome();



    }, 7000);



  }



  const menuToggle = select('[data-menu-toggle]');



  const mobileMenu = select('#MobileMenu');



  const searchToggle = select('[data-search-toggle]');



  const search = select('#HeaderSearch');



  function closeMenu() {



    if (!mobileMenu) return;



    mobileMenu.hidden = true;



    menuToggle?.setAttribute('aria-expanded', 'false');



    menuToggle?.setAttribute('aria-label', 'Open menu');



  }



  function closeSearch() {



    if (!search) return;



    search.hidden = true;



    searchToggle?.setAttribute('aria-expanded', 'false');



  }



  menuToggle?.addEventListener('click', () => {



    const open = menuToggle.getAttribute('aria-expanded') !== 'true';



    menuToggle.setAttribute('aria-expanded', String(open));



    menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');



    mobileMenu.hidden = !open;



    if (open) closeSearch();



  });



  searchToggle?.addEventListener('click', () => {



    const open = searchToggle.getAttribute('aria-expanded') !== 'true';



    searchToggle.setAttribute('aria-expanded', String(open));



    search.hidden = !open;



    if (open) { closeMenu(); select('#SearchInput')?.focus(); }



  });



  let headerScrolled = null;

  let headerFramePending = false;

  function updateHeaderScroll() {

    headerFramePending = false;

    const scrolled = window.scrollY > 24;

    if (scrolled !== headerScrolled) {

      header?.classList.toggle('is-scrolled', scrolled);

      headerScrolled = scrolled;

    }

  }

  updateHeaderScroll();

  window.addEventListener('scroll', () => {

    if (!headerFramePending) {

      headerFramePending = true;

      requestAnimationFrame(updateHeaderScroll);

    }

  }, { passive: true });



  const drawer = select('#CartDrawer');



  const backdrop = select('.drawer-backdrop');



  let previousFocus;



  if (drawer) drawer.inert = true;



  function closeCart() {



    if (!drawer || drawer.getAttribute('aria-hidden') === 'true') return;



    drawer.setAttribute('aria-hidden', 'true');



    drawer.inert = true;



    backdrop.hidden = true;



    document.body.classList.remove('drawer-open');



    previousFocus?.focus();



  }



  async function renderCart() {
    const response = await fetch(`${root}cart?section_id=cart-drawer-items`, { headers: { 'Accept': 'text/html' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Cart could not load');
    const content = new DOMParser().parseFromString(await response.text(), 'text/html');
    const cart = content.querySelector('[data-rendered-cart]');
    const items = cart?.querySelector('[data-rendered-cart-items]');
    if (!cart || !items) throw new Error('Cart could not load');
    const count = Number(cart.dataset.itemCount);
    selectAll('[data-cart-count], [data-drawer-count]').forEach(el => { el.textContent = count; });
    select('[data-cart-subtotal]').textContent = cart.dataset.subtotal;
    select('[data-cart-items]').innerHTML = items.innerHTML;
    select('[data-checkout-link]').href = count ? `${root}checkout` : `${root}collections/all`;
    select('[data-checkout-link]').textContent = count ? 'CHECKOUT ↗' : 'EXPLORE THE VAULT ↗';
  }

  async function openCart() {



    if (!drawer) return;



    closeWelcome();



    previousFocus = document.activeElement;



    drawer.setAttribute('aria-hidden', 'false');



    drawer.inert = false;



    backdrop.hidden = false;



    document.body.classList.add('drawer-open');



    select('[data-cart-close]', drawer)?.focus();



    try { await renderCart(); } catch { select('[data-cart-items]').textContent = 'Cart could not load. Please use the cart page.'; }



  }



  selectAll('[data-cart-open]').forEach(button => button.addEventListener('click', openCart));



  selectAll('[data-cart-close]').forEach(button => button.addEventListener('click', closeCart));



  document.addEventListener('keydown', event => {



    if (event.key === 'Escape') {



      if (drawer?.getAttribute('aria-hidden') === 'false') closeCart();



      else if (welcome && !welcome.hidden) closeWelcome();



      else if (search && !search.hidden) { closeSearch(); searchToggle?.focus(); }



      else if (mobileMenu && !mobileMenu.hidden) { closeMenu(); menuToggle?.focus(); }



    }



    if (event.key === 'Tab' && drawer?.getAttribute('aria-hidden') === 'false') {



      const focusable = selectAll('a[href], button:not([disabled]), input:not([disabled])', drawer);



      const first = focusable[0], last = focusable[focusable.length - 1];



      if (!first || !last) return;



      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }



      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }



    }



  });



  drawer?.addEventListener('change', async event => {



    const input = event.target.closest('[data-cart-line]'); if (!input) return;



    try {



      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(input.dataset.cartLine), quantity: Math.max(0, Number(input.value) || 0) }) });



      if (!response.ok) throw new Error(); await renderCart();



    } catch { select('[data-cart-items]').insertAdjacentHTML('afterbegin', '<p role="alert">Could not update cart. Please try again.</p>'); }



  });



  drawer?.addEventListener('click', event => {



    const button = event.target.closest('[data-remove-line]'); if (!button) return;



    const input = select(`[data-cart-line="${button.dataset.removeLine}"]`, drawer); if (input) { input.value = 0; input.dispatchEvent(new Event('change', { bubbles: true })); }



  });



  const product = select('[data-product-section]');



  if (product) {



    const form = select('#ProductForm', product);



    let currentVariant = JSON.parse(select('[data-selected-variant]', product).textContent);



    let variantRequest;



    let variantLoading = false;

    let cartAdding = false;



    let selectionVersion = 0;



    const variantCache = new Map();



    const stateCache = new Map();



    const initialState = select('[data-variant-state]', product);



    const optionKey = options => JSON.stringify(options);



    function rememberState(state) {



      [state.selected, ...state.adjacent].filter(Boolean).forEach(variant => variantCache.set(optionKey(variant.options), variant));



    }



    if (initialState) rememberState(JSON.parse(initialState.textContent));



    const checkedOptions = () => selectAll('[data-option-position]:checked', form);



    const selectedKey = () => optionKey(checkedOptions().map(input => input.value));



    if (currentVariant) variantCache.set(optionKey(currentVariant.options), currentVariant);



    function selectedVariant() {



      return currentVariant;



    }



    let destinationConfig;

    try { destinationConfig = JSON.parse(select('[data-delivery-config]', product)?.textContent || '{}'); } catch { destinationConfig = {}; }

    let blockedVariantIds;

    try { blockedVariantIds = new Set(JSON.parse(select('[data-blocked-variants]', product)?.textContent || '[]').map(String)); } catch { blockedVariantIds = new Set(); }

    const blockedDestination = variant => blockedVariantIds.has(String(variant?.id)) || destinationConfig.variants?.[String(variant?.id)]?.unavailable_countries?.includes(select('[data-delivery-country]', product)?.value);



    function setGalleryImage(image, source, alt, aspectRatio) {
      const next = new URL(source, location.origin);
      const previous = new URL(image.src, location.origin);
      // Keep the server's responsive source on initial selection and size-only changes.
      if (previous.pathname !== next.pathname || previous.searchParams.get('v') !== next.searchParams.get('v')) {
        const ratio = Number(aspectRatio) || 1;
        const mobile = Math.min(1, ratio * 1.05), desktop = Math.min(1, ratio * 1.125);
        image.sizes = `(max-width: 600px) calc(${100 * mobile}vw - ${32 * mobile}px), (max-width: 800px) calc(${100 * mobile}vw - ${48 * mobile}px), (max-width: 1328px) calc(${55.46 * desktop}vw - ${28.32 * desktop}px), ${708.2 * desktop}px`;
        const widths = [320, 400, 500, 600, 750, 900, 1100, 1400];
        image.srcset = widths.map(width => { const url = new URL(next); url.searchParams.set('width', width); return `${url.href} ${width}w`; }).join(', ');
        next.searchParams.set('width', '900'); image.src = next.href;
      }
      image.alt = alt || '';
    }
    const thumbnails = selectAll('[data-thumbnail-src]', product);
    const loadThumbnail = image => {
      if (image.dataset.thumbnailSrcset) image.srcset = image.dataset.thumbnailSrcset;
      image.src = image.dataset.thumbnailSrc;
      delete image.dataset.thumbnailSrc; delete image.dataset.thumbnailSrcset;
    };
    if (thumbnails.length && typeof IntersectionObserver !== 'undefined') {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { loadThumbnail(entry.target); observer.unobserve(entry.target); }
      }), { root: select('.gallery-thumbs', product), rootMargin: '100px' });
      thumbnails.forEach(image => observer.observe(image));
    } else thumbnails.forEach(loadThumbnail);

    const purchaseButtons = () => [select('[data-add-button]', form), ...selectAll('[data-sticky-add]', product)].filter(Boolean);

    function syncPurchaseUI() {

      const available = !!currentVariant?.available && product.dataset?.destinationEligible !== 'false' && !blockedDestination(currentVariant);

      purchaseButtons().forEach(button => { button.disabled = cartAdding || variantLoading || !available; });

      const sticky = select('[data-sticky-add]', product);

      if (sticky) sticky.textContent = cartAdding ? 'Adding…' : variantLoading ? 'Checking…' : available ? 'Add to cart' : blockedDestination(currentVariant) || product.dataset?.destinationEligible === 'false' ? 'Unavailable here' : currentVariant ? 'Sold out' : 'Unavailable';

      const price = select('[data-sticky-price]', product);

      if (price) price.textContent = currentVariant ? money(currentVariant.price) : 'Check option';

      const choice = select('[data-sticky-choice]', product);

      if (choice) choice.textContent = currentVariant?.options?.join(' / ') || '';

      const offer = select('[data-product-discount]', product);

      if (offer && currentVariant) offer.href = `${root}discount/WELCOME10?redirect=${encodeURIComponent(location.pathname + '?variant=' + currentVariant.id)}`;

    }

    function updateChoiceLabels() {

      const inputs = checkedOptions();

      selectAll('[data-choice-selected]', form).forEach(label => { label.textContent = inputs[Number(label.dataset.choiceSelected) - 1]?.value || 'Choose an option'; });

    }



    function renderVariant(variant) {



      currentVariant = variant;



      select('[data-variant-id]', form).value = variant?.id || '';



      product.dispatchEvent(new CustomEvent('anivault:variant-change'));



      const available = !!variant?.available && product.dataset?.destinationEligible !== 'false' && !blockedDestination(variant);



      const button = select('[data-add-button]', form);



      button.disabled = !available;



      button.textContent = blockedVariantIds.has(String(variant?.id)) ? 'OPTION UNAVAILABLE' : product.dataset?.destinationEligible === 'false' || blockedDestination(variant) ? 'UNAVAILABLE FOR YOUR COUNTRY' : variant ? (available ? `ADD TO CART — ${money(variant.price)}` : 'SOLD OUT') : 'UNAVAILABLE';



      select('[data-availability]', product).innerHTML = available ? '<span class="status-dot"></span> AVAILABLE' : 'UNAVAILABLE';



      if (variant) select('[data-product-price]', product).innerHTML = `${money(variant.price)}${variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s>` : ''}`;
      const saleOptions = select('[data-product-sale-options]', product);
      if (saleOptions) saleOptions.hidden = !variant || variant.compare_at_price > variant.price;



      if (variant?.featured_image?.src) {



        const image = select('.active-product-image', product);



        if (image) {



          const imageUrl = new URL(variant.featured_image.src, location.origin); imageUrl.searchParams.set('width', '1000');



          setGalleryImage(image, imageUrl.href, variant.featured_image.alt || variant.options.join(' / '), variant.featured_image.aspect_ratio || variant.featured_image.width / variant.featured_image.height);



          image.alt = variant.featured_image.alt || variant.options.join(' / ');



          selectAll('[data-image-url]', product).forEach(thumb => {



            const matches = new URL(thumb.dataset.imageUrl, location.origin).pathname === imageUrl.pathname;



            if (matches) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');



          });



        }



      }



      const url = new URL(location.href); url.searchParams.delete('option_values');



      if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');



      history.replaceState({}, '', url);

      updateChoiceLabels();

      syncPurchaseUI();



    }



    async function syncVariant() {



      variantRequest?.abort();



      const version = ++selectionVersion;



      const request = new AbortController(); variantRequest = request;



      const error = select('[data-product-error]', form); error.hidden = true;



      const key = selectedKey();

      updateChoiceLabels();



      const cached = variantCache.get(key);



      variantLoading = !cached;



      if (cached) renderVariant(cached);



      else {



        currentVariant = null;



        const button = select('[data-add-button]', form); button.disabled = true; button.textContent = 'CHECKING OPTION…';



        select('[data-variant-id]', form).value = '';

        syncPurchaseUI();



      }



      if (stateCache.has(key)) { variantLoading = false; renderVariant(stateCache.get(key).selected); return; }



      const url = new URL(location.href); url.searchParams.delete('variant');



      url.searchParams.set('section_id', 'variant-state');



      url.searchParams.set('option_values', checkedOptions().map(input => input.dataset.optionValueId).join(','));



      try {



        const response = await fetch(url, { signal: request.signal });



        if (!response.ok) throw new Error('Could not check this option. Please try again.');



        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');



        if (selectionVersion !== version) return;



        const data = select('[data-variant-state]', doc);



        if (!data) throw new Error('Could not check this option. Please refresh the page.');



        const state = JSON.parse(data.textContent);



        if (state.selected && optionKey(state.selected.options) !== key) throw new Error('Could not match this option. Please try again.');



        rememberState(state); stateCache.set(key, state);



        renderVariant(state.selected);



      } catch (e) {



        if (e.name === 'AbortError' || selectionVersion !== version) return;



        if (!cached) { renderVariant(null); error.textContent = e.message; error.hidden = false; }



      } finally { if (selectionVersion === version) { variantLoading = false; syncPurchaseUI(); } }



    }



    form?.addEventListener('change', event => {

      if (event.target.matches('[data-option-position]')) {

        const picker = event.target.closest?.('[data-option-picker]');

        if (picker) picker.open = false;

        syncVariant();

      }

    });

    select('[data-delivery-country]', product)?.addEventListener('change', () => renderVariant(currentVariant));

    if (blockedDestination(currentVariant)) renderVariant(currentVariant);

    syncPurchaseUI();

    selectAll('[data-option-search-label]', form).forEach(label => { label.hidden = false; });

    selectAll('[data-option-search]', form).forEach(input => input.addEventListener('input', () => {

      const field = input.closest('fieldset');

      const term = input.value.trim().toLocaleLowerCase();

      let matches = 0;

      selectAll('[data-option-label]', field).forEach(label => { label.hidden = !label.textContent.toLocaleLowerCase().includes(term); if (!label.hidden) matches++; });

      const status = select('[data-option-search-status]', field);

      status.hidden = !term; status.textContent = matches ? `${matches} matching choices` : 'No matching choices. Try another name.';

    }));

    const purchaseBar = select('[data-mobile-purchase]', product);

    if (purchaseBar && typeof IntersectionObserver !== 'undefined') {

      new IntersectionObserver(entries => { purchaseBar.hidden = entries[0].isIntersecting; }, { threshold: 0.5 }).observe(select('[data-add-button]', form));

    }



    select('[data-qty-minus]', form)?.addEventListener('click', () => { const input = select('[name="quantity"]', form); input.value = Math.max(1, Number(input.value) - 1); });



    select('[data-qty-plus]', form)?.addEventListener('click', () => { const input = select('[name="quantity"]', form); input.value = Math.max(1, Number(input.value) + 1); });



    form?.addEventListener('submit', async event => {



      if (event.submitter?.name !== 'add') return;



      event.preventDefault();



      if (cartAdding || variantLoading || !currentVariant?.available || product.dataset?.destinationEligible === 'false' || blockedDestination(currentVariant)) return;



      const error = select('[data-product-error]', form); error.hidden = true;



      const button = select('[data-add-button]', form); button.disabled = true;

      cartAdding = true; syncPurchaseUI();



      try {



        const fields = new FormData(form);
        const quantity = Number(fields.get('quantity'));
        const variantId = Number(currentVariant.id);
        if (!Number.isSafeInteger(variantId) || variantId <= 0 || !Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Choose a valid option and quantity before adding it.');
        const properties = {};
        for (const [name, value] of fields) {
          const property = name.match(/^properties\[(.+)\]$/);
          if (property && typeof value === 'string') properties[property[1]] = value;
        }
        const item = { id: variantId, quantity, properties };
        const sellingPlan = fields.get('selling_plan');
        if (sellingPlan) item.selling_plan = sellingPlan;
        const addItem = () => fetch(`${root}cart/add.js`, { method: 'POST', body: JSON.stringify({ items: [item] }), headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, credentials: 'same-origin' });
        let response = await addItem();
        if (response.status === 422) {
          const failure = await response.clone().json();
          if (/already sold out/i.test(failure.description || '')) {
            const cartResponse = await fetch(`${root}cart.js`, { cache: 'no-store', credentials: 'same-origin' });
            const cart = cartResponse.ok ? await cartResponse.json() : null;
            const productResponse = await fetch(`${location.pathname}.js`, { cache: 'no-store', credentials: 'same-origin' });
            const freshProduct = productResponse.ok ? await productResponse.json() : null;
            const freshVariant = freshProduct?.variants?.find(variant => Number(variant.id) === variantId);
            if (freshVariant && !freshVariant.available && Number(currentVariant?.id) === variantId) {
              variantCache.set(optionKey(freshVariant.options), freshVariant);
              stateCache.clear();
              renderVariant(freshVariant);
            }
            if (cart?.item_count === 0 && freshVariant?.available && !blockedDestination(currentVariant)) {
              // Renew only an empty cart. Never discard a customer's existing items.
              for (const name of ['cart', 'cart_sig']) {
                document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
                document.cookie = `${name}=; Max-Age=0; path=/; domain=${location.hostname}; SameSite=Lax`;
              }
              response = await addItem();
            }
          }
        }

        if (!response.ok) { const data = await response.json(); throw new Error(data.description || 'Could not add this item'); }


        await openCart();



      } catch (e) { error.textContent = e.message; error.hidden = false; }



      finally { cartAdding = false; syncPurchaseUI(); }



    });



    selectAll('[data-image-url]', product).forEach(button => button.addEventListener('click', () => {



      const image = select('.active-product-image', product); if (!image) return;



      setGalleryImage(image, button.dataset.imageUrl, button.dataset.imageAlt, button.dataset.imageAspectRatio);



      selectAll('[data-image-url]', product).forEach(other => other.removeAttribute('aria-current'));



      button.setAttribute('aria-current', 'true');



    }));



  }



  select('[data-filter-toggle]')?.addEventListener('click', event => {



    const panel = select('#CollectionFilters'); const open = event.currentTarget.getAttribute('aria-expanded') !== 'true';



    event.currentTarget.setAttribute('aria-expanded', String(open)); panel.classList.toggle('filter-open', open);



  });



  async function loadRecommendations(section) {



    try {



      const url = `${root}recommendations/products?product_id=${encodeURIComponent(section.dataset.productId)}&section_id=${encodeURIComponent(section.dataset.sectionId)}&limit=4`;



      const response = await fetch(url); if (!response.ok) return;



      const html = document.createElement('div'); html.innerHTML = await response.text();



      const cards = select('.product-grid', html); if (cards?.children.length) select('.product-grid', section).innerHTML = cards.innerHTML;



    } catch { /* Optional recommendations must not block commerce. */ }



  }

  const recommendationSections = selectAll('[data-recommendations]');

  if (typeof IntersectionObserver !== 'undefined' && !window.Shopify?.designMode) {

    const recommendationObserver = new IntersectionObserver(entries => {

      entries.forEach(entry => {

        if (!entry.isIntersecting) return;

        recommendationObserver.unobserve(entry.target);

        loadRecommendations(entry.target);

      });

    }, { rootMargin: '400px' });

    recommendationSections.forEach(section => recommendationObserver.observe(section));

  } else {

    recommendationSections.forEach(loadRecommendations);

  }



})();



